import { atom } from 'recoil';

export const dataCommerceFormBene = atom({
  key: 'dataCommerceFormBene',
  default: undefined,
});
